import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const supportModule = defineModule({
  name: "support",
  label: "Support tickets",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "medialib",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
    "products",
    "logistics",
    "cart",
    "payments",
    "payouts",
    "orders",
  ],
  i18n: { en },
  // Admin step 17 / vendor step 15 (P5-07); the customer's pages come with the storefront (P6-10).
  admin: {
    routes: [
      {
        path: "tickets",
        permission: "support.view_ticket",
        page: () => import("./admin/TicketsPage"),
      },
      {
        path: "tickets/:number",
        permission: "support.view_ticket",
        page: () => import("./admin/TicketPage"),
      },
      {
        path: "settings/ticket-categories",
        permission: "support.view_ticketcategory",
        page: () => import("./admin/CategoriesPage"),
      },
    ],
    nav: [
      {
        id: "tickets",
        group: "support",
        label: "support:nav.tickets",
        icon: "life-buoy",
        to: "/tickets",
        permission: "support.view_ticket",
        order: 1,
      },
      {
        id: "ticket-categories",
        group: "support",
        label: "support:nav.categories",
        icon: "list",
        to: "/settings/ticket-categories",
        permission: "support.view_ticketcategory",
        order: 2,
      },
    ],
  },
  vendor: {
    routes: [
      { path: "tickets", permission: "store.view", page: () => import("./vendor/TicketsPage") },
      {
        path: "tickets/:number",
        permission: "store.view",
        page: () => import("./vendor/TicketPage"),
      },
    ],
    nav: [
      {
        id: "tickets",
        group: "support",
        label: "support:nav.support",
        icon: "life-buoy",
        to: "/tickets",
        permission: "store.view",
        order: 1,
      },
    ],
  },
});
